import { action } from 'satcheljs';

/**
 * Triggers the satchel v2 action for closeQuickComposeForm so the stitches (which are satchel v2 subscriptions)
 * for surface are able to successfully fire.
 *
 */
let closeQuickComposeForm = action('closeQuickComposeForm');
export default closeQuickComposeForm;
